import baseApi from 'services/api/base';
import { GetProductLinksReponse } from 'helper/products/home';

const MOCK_URL = process.env.REACT_APP_MOCK_API_URL;

// MOCK_URL setada → URL absoluta pro json-server (fetchBaseQuery ignora o baseUrl).
// MOCK_URL vazia  → URL relativa → baseApi usa REACT_APP_AMPERE_API_URL (API real).
export const homeProductLinksUrl = (): string => (MOCK_URL
  ? `${MOCK_URL}/home-product-links`
  : 'home-product-links');

export const homeDataApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getProductLinks: build.query<GetProductLinksReponse, void>({
      query: () => homeProductLinksUrl(),
    }),
  }),
});

export const {
  useGetProductLinksQuery,
} = homeDataApi;
